import { InMemoryCache } from '@apollo/client';
import * as sessionStorage from '@cobra/fe-lib/services/shop-session-storage.service';

export function createCache() {
    return new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    verifiedAddress: {
                        merge(_, incoming) {
                            const { street, houseNumber, zip, city, areaCode } = incoming;
                            sessionStorage.storeVerifiedAddress({
                                street,
                                houseNumber,
                                zip,
                                city,
                                areaCode,
                            });
                            return incoming;
                        },
                    },
                    availableProducts: {
                        merge(_, incoming) {
                            sessionStorage.storeAvailableProducts(incoming);
                            return incoming;
                        },
                    },
                    searchResultUuid: {
                        merge(_, incoming) {
                            sessionStorage.storeSearchUuid(incoming);
                            return incoming;
                        },
                    },
                    productConfiguration: {
                        merge(_, incoming) {
                            const { product, companionProducts, options } = incoming;
                            sessionStorage.storeProductConfig({ product, companionProducts, options });
                            return incoming;
                        },
                    },
                },
            },
        },
    });
}
